const QualityControlIndex = () => import("@/pages/lab/qualitycontrol/QualityControlIndex");
const QualityControlAdd = () => import("@/pages/lab/qualitycontrol/QualityControlAdd");
const QualityControlSingle = () => import("@/pages/lab/qualitycontrol/QualityControlSingle");
const QualityControlDetail = () => import("@/pages/lab/qualitycontrol/QualityControlDetail");
const QualityControlEdit = () => import("@/pages/lab/qualitycontrol/QualityControlEdit");
const QualityControlAuditTrail = () => import("@/pages/lab/qualitycontrol/QualityControlAuditTrail");
const QualityControlAuditTrailHistory = () => import("@/pages/lab/qualitycontrol/QualityControlAuditTrailHistory");

export class QualityControlRoutes {
    constructor() {
        this.route_root = 'quality-control';
        this.type_single = 'Quality Control';
        this.type_plural = 'Quality Control';

        this.routes = [
            {
                path: this.route_root,
                component: {
                    render(c) {
                        return c('router-view');
                    }
                },
                redirect: this.route_root,
                name: this.type_plural,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: "",
                        name: `List ${this.type_plural}`,
                        component: QualityControlIndex,
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "add",
                        name: `Add ${this.type_single}`,
                        component: QualityControlAdd,
                        meta: { requiresAuth: true },
                        props: true
                    },
                    {
                        path: ":quality_control_id",
                        component: QualityControlSingle,
                        children: [
                            {
                                path: "",
                                component: QualityControlDetail,
                                name: this.type_single,
                                meta: { requiresAuth: true },
                            },
                            {
                                path: "edit",
                                component: QualityControlEdit,
                                name: `Update ${this.type_single}`,
                                meta: { requiresAuth: true },
                            },
                            {
                                path: "audit-trail",
                                name: `${this.type_single} Audit Trail`,
                                component: QualityControlAuditTrail,
                                meta: { requiresAuth: true },
                            },
                            {
                                path: "audit-trail-history",
                                name: `${this.type_single} Audit Trail History`,
                                component: QualityControlAuditTrailHistory,
                                meta: { requiresAuth: true },
                            }
                        ],
                    },
                ],
            },
        ];

        this.public_routes = [];
    }

    static fetchRoutes() {
        let this_obj = new this();
        return this_obj.routes;
    }

    static fetchPublicRoutes() {
        let this_obj = new this();
        return this_obj.public_routes;
    }
}